<template>
	<r-standard-modal-form
		class="new-column-modal-outter"
		@closeModal="$emit('closeModal')">
		<span slot="title">{{ titleText }}</span>
		<div slot="body" class="new-column-modal-body">
			<div v-if="subtitleText" class="subtitle-container">
				<span class="subtitle-text">{{ subtitleText }}</span>
			</div>
			<div class="input-header">{{ columnText }} Type</div>
			<div class="type-container">
				<div class="radio-container">
					<div v-for="(fieldDefStruct, index) in newFieldListForMenu" :key="fieldDefStruct.fieldKey">
						<input
							type="radio"
							:id="fieldDefStruct.fieldKey"
							name="columnTypes"
							:value="fieldDefStruct.fieldKey"
							:checked="index === 0"
							:disabled="fieldDefStruct.disabled"
							v-model="columnType"/>
						<label
							:for="fieldDefStruct.fieldKey"
							:class="fieldDefStruct.disabled ? 'radio-label disabled' : 'radio-label'">
							<r-standard-icon
								v-if="columnType === fieldDefStruct.fieldKey"
								icon="radioCheckmark"
								:size="{
									height: 15,
									width: 15,
								}"
								:containerSize="{
									height: 15,
									width: 15,
								}"
								class="check-icon"
							></r-standard-icon>
							<div v-else class="check-spacer"></div>
							<span>{{ fieldDefStruct.fieldDetails.display.fieldTypeLabel }}</span>
						</label>
					</div>
					<div v-for="ignoredFieldType in ignoredFieldTypes" class="ignored-radio-label" />
				</div>
				<div class="describe-container">
					<div
						class="svg-container"
						:class="{
							'fixed-height': showFeatures,
						}" >
						<component
							v-if="currentColumnTypeExample"
							:is="currentColumnTypeExample" />
					</div>
					<div v-if="showFeatures" class="features-container">
						<div
							class="column-feature"
							v-for="(
								featureStruct, index
							) in currentColumnTypeFeatures"
							:key="featureStruct.key"
						>
							<svg
								v-if="featureStruct.enabled"
								class="feature-icon"
								width="18"
								height="18"
								viewBox="0 0 18 18"
								fill="none"
							>
								<path
									d="M5 10L7.66667 12.4L13 6"
									stroke="#6A6B76"
									stroke-width="2"
								/>
							</svg>
							<svg
								v-else
								class="feature-icon"
								width="18"
								height="18"
								viewBox="0 0 18 18"
								fill="none"
							>
								<rect
									x="4.75732"
									y="11.8281"
									width="10"
									height="2"
									transform="rotate(-45 4.75732 11.8281)"
									fill="#6A6B76"
								/>
								<rect
									x="6.17163"
									y="4.75684"
									width="10"
									height="2"
									transform="rotate(45 6.17163 4.75684)"
									fill="#6A6B76"
								/>
							</svg>
							<span class="feature-label">{{
								featureStruct.label
							}}</span>
						</div>
					</div>
				</div>
			</div>
			<div
				v-if="showColumnNameInput"
				class="input"
				:style="{
					opacity: showColumnNameInput ? 1 : 0,
					'pointer-events': showColumnNameInput ? 'all' : 'none',
				}">
				<div class="input-header">{{ columnText }} Name</div>
				<div class="name-container">
					<input
						class="name-input"
						v-model="columnName"
						:placeholder="inputPlaceholder"
						@keyup.enter.stop.prevent="submitColumn"
					/>
				</div>
			</div>
			<div v-if="showEELPicker" class="input">
				<div class="input-header">Pick a Connection</div>
				<r-input-select
					v-model="selectedEEL"
					:choiceArray="linkedRecords"
					:defaultToFirstChoice="true"
					:containerWidth="264" />
			</div>
			<p-button
				type="primary"
				class="submit-button"
				:disabled="!((columnName !== null && columnName.length > 0) || columnType === 'externalEntityField' || columnType === 'externalEntityLink')"
				@onClick="submitColumn">{{ buttonText }}</p-button>
		</div>
	</r-standard-modal-form>
</template>
<script>
import DataStoreFields from "js/data-store/data-store-fields/data-store-fields";
import BackgroundBus from "js/bus/background-bus";
import ConnectedApps from "js/connected-apps/connected-apps";
import ConnectedAppManifest from "js/connected-apps/connected-app-manifest";
import * as DataStoreHelpers from "js/data-store/data-store-fields/data-store-fields-helpers";

export default {
	name: "new-column-modal",
	data() {
		return {
			columnType: null,
			columnName: null,
			selectedEEL: ""
		};
	},
	$pubsub: {
		dropdownOptionsModal: {},
	},
	components: {},
	props: {
		sheetView: {
			required: true,
			type: Object,
		},
		// Contains an anchorFieldGUID and a direction: 0 for left, 1 for right
		overrideObject: {
			required: false,
			type: Object,
		},
	},
	mounted() {
		this.columnType = this.newFieldListForMenu[0].fieldKey;
		// this.columnName = `${this.columnText} ${this.totalColumns}`;
		const focusable = this.$el.querySelectorAll(
			'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
		);
		if (focusable[0] && focusable[0].focus) {
			focusable[0].focus();
		}
	},
	computed: {
		schema() {
			return this.dataStore.meta.schema;
		},
		dataStore() {
			return this.sheetView.sheetViewGroup.dataStore;
		},
		totalColumns() {
			return Object.keys(this.schema.fields).length;
		},
		fieldTypeList() {
			if (this.overrideObject && this.overrideObject.fieldType) {
				return [this.overrideObject.fieldType];
			}
			return Object.keys(DataStoreFields.fieldTypes);
		},
		ignoredFieldTypes() {
			const vcSelf = this;
			return Object.keys(DataStoreFields.fieldTypes).filter(
				function removeExcluded(fieldType) {
					return (
						DataStoreFields.fieldTypes[fieldType].display
							.sortOrder >= 0 &&
						!vcSelf.fieldTypeList.includes(fieldType)
					);
				}
			);
		},
		newFieldListForMenu() {
			const vcSelf = this;
			return this.fieldTypeList.map(function mapFields(fieldKey) {
					return {
						fieldKey,
						fieldDetails: DataStoreFields.fieldTypes[fieldKey],
						disabled: vcSelf.linkedRecords.length === 0 && fieldKey === "externalEntityField"
					};
				}).filter(function filterOutExcludedFields(fieldDefStruct) {
					return fieldDefStruct.fieldDetails.display.sortOrder >= 0;
				}).sort(function sortByOrder(fieldDefStructA, fieldDefStructB) {
					return (
						fieldDefStructA.fieldDetails.display.sortOrder -
						fieldDefStructB.fieldDetails.display.sortOrder
					);
				});
		},
		titleText() {
			if (this.overrideObject && this.overrideObject.title) {
				return this.overrideObject.title;
			}
			return `Add a ${this.columnText}`;
		},
		columnText() {
			return "Field";
			// if(this.overrideObject && this.overrideObject.fieldTerminology !== undefined){
			// 	return "Field";
			// }
			// return "Column";
		},
		inputPlaceholder() {
			if (this.columnType) {
				return `ex: "${DataStoreFields.fieldTypes[this.columnType].display.placeholder}"`;
			}
			return "";
		},
		buttonText() {
			if (this.columnType) {
				if (this.columnType === "externalEntityLink") {
					return "Add a new connection";
				} else if (this.columnType === "externalEntityField") {
					return "Add a connected field";
				} else if (this.columnType === "select") {
					return "Proceed to Dropdown Choices";
				} else {
					return `Add ${DataStoreFields.fieldTypes[this.columnType].display.fieldTypeLabel} ${this.columnText}`;
				}
			} else {
				return `Add ${this.columnText}`;
			}
		},
		currentColumnTypeLabel() {
			if (this.columnType) {
				return DataStoreFields.fieldTypes[this.columnType].display
					.label;
			} else {
				return "";
			}
		},
		currentColumnTypeFeatures() {
			if (this.columnType) {
				return DataStoreFields.fieldTypes[this.columnType].display
					.features;
			} else {
				return [];
			}
		},
		currentColumnTypeExample() {
			if (this.columnType) {
				if (this.overrideObject && this.overrideObject.example) {
					return this.overrideObject.example;
				} else {
					return DataStoreFields.fieldTypes[this.columnType].display
						.example;
				}
			} else {
				return null;
			}
		},
		showFeatures() {
			if (
				this.overrideObject &&
				this.overrideObject.showFeatures !== undefined
			) {
				return this.overrideObject.showFeatures;
			}
			return true;
		},
		subtitleText() {
			if (this.overrideObject && this.overrideObject.subtitle) {
				return this.overrideObject.subtitle;
			}
			return null;
		},
		showColumnNameInput() {
			return !["externalEntityLink", "externalEntityField"].includes(this.columnType);
		},
		showEELPicker() {
			return this.columnType === "externalEntityField";
		},
		linkedRecords() {
			const systemState = this.$root.systemState;
			const dataStore = this.$root.systemState.applicationData.activeWorkbook.dataStore;
			const schemaObject = dataStore.meta.schema;
			return Object.keys(schemaObject.fields).filter(function checkIsEEL(fieldGUID) {
				return schemaObject.fields[fieldGUID].field.fieldType === "externalEntityLink";
			}).map(function schemaStruct(fieldGUID) {
				let connectedAppName = schemaObject.fields[fieldGUID].field.attributes.connectedAppName;
				const eefDetails = DataStoreHelpers.getEEFDetails({
					dataStore,
					systemState,
					fieldGUID
				});
				const eelLabel = ConnectedApps.services[eefDetails.connectedAppName].getEELFieldLabel({ dataStore, systemState, fieldGUID, eefDetails });
				return {
					value: fieldGUID,
					label: schemaObject.fields[fieldGUID].display.label,
					icon: ConnectedApps.services[connectedAppName].getApplicationDisplayIconNameLegacy(),
					eelLabel: eelLabel,
					connectedAppName: connectedAppName,
					schema: schemaObject.fields[fieldGUID],
				}
			}).sort(function comparator(itemA, itemB) {
				let compare = ConnectedAppManifest.appSortedList.indexOf(itemA.connectedAppName) - ConnectedAppManifest.appSortedList.indexOf(itemB.connectedAppName);
				if (compare === 0) {
					return itemA.label.localeCompare(itemB.label);
				} else {
					return compare;
				}
			});
		}
	},
	methods: {
		submitColumn() {
			this.$emit("closeModal");
			BackgroundBus.pub("Registration", "conversionObjectiveCompleted", {
				objectiveName: "workbookFieldAdded",
				objectiveDetails: {
					values: [this.columnType]
				}
			});
			if (this.columnType === "externalEntityLink") {
				BackgroundBus.pub("Registration", "conversionObjectiveCompleted", {
					objectiveName: "addedExternalEntityLinkField",
					objectiveDetails: {
						values: [this.selectedConnectedApp]
					}
				});
				// allow the selected connected app to decide what to do next
				this.$pubsub.modules.integrationManagement.pub("openModal", {
					flowName: "createNewConnection",
					attributes: {
						isSidebarShown: this.$root.systemState.applicationData.activeWorkbook.dataStore.meta.schema.getArrayOfFieldsGUIDsMatchingType("externalEntityLink").length > 0
					}
				});
			} else if (this.columnType === "externalEntityField") {
				let connectedAppName = this.$root.systemState.applicationData.activeWorkbook.dataStore.meta.schema.fields[this.selectedEEL].field.attributes.connectedAppName;
				this.$pubsub.modules.integrationManagement.pub("openModal", {
					flowName: "editConnection",
					attributes: {
						connectedAppName,
						selectedExternalEntityLinkGUID: this.selectedEEL
					}
				});
			} else {
				let addFieldGUID = this.createNewField();
				if (this.overrideObject && this.overrideObject.onCompletedCallback) {
					this.overrideObject.onCompletedCallback(
						this.sheetView,
						addFieldGUID
					);
				}
				if (this.columnType === "select") {
					this.$pubsub.modules.dropdownOptionsModal.pub("openModal", {
						sheetView: this.sheetView,
						fieldGUID: addFieldGUID,
					});
				}
				if (this.overrideObject && this.overrideObject.setRelativeColumnLocation) {
					this.sheetView.addColumnInSortedOrder(addFieldGUID, this.overrideObject.setRelativeColumnLocation.anchorFieldGUID, this.overrideObject.setRelativeColumnLocation.direction);
				}
			}
		},
		createNewField() {
			return this.dataStore.addField(
				this.columnType,
				this.columnName || `Untitled ${this.columnText}`
			);
		},
	},
};
</script>
<style scoped lang="scss">
.new-column-modal-outter {
	width: 100%;
	.new-column-modal-body {
		width: 100%;
		.subtitle-container {
			margin-bottom: 12px;
			.subtitle-text {
				font-family: $rvFontFamily;
				font-weight: 300;
				font-size: 13px;
				line-height: 19px;
				letter-spacing: 0.15px;
				color: $p-color-grey-600;
			}
		}
		.input-header {
			font-family: $rvFontFamily;
			font-weight: 600;
			font-size: 13px;
			line-height: 19px;
			letter-spacing: 0.01em;
			color: $p-color-grey-400;
			margin-bottom: 6px;
		}
		.type-container {
			@include flex(row, flex-start, flex-start);
			margin-bottom: 24px;
			.radio-container {
				.radio-label {
					&:not(.disabled) {
						@include clickable;
					}
					&.disabled {
						color: $p-color-grey-300 !important;
					}
					@include flex(row);
					width: 144px;
					.check-icon {
						padding: 0 6px;
					}
					.check-spacer {
						width: 27px;
					}
				}
				.ignored-radio-label {
					width: 118px;
					height: 38px;
					background-color: $p-color-grey-100;
				}
			}
			.radio-container input[type="radio"] {
				opacity: 0;
				position: fixed;
				width: 0;
			}
			.radio-container label {
				display: block;
				padding: 9px 0;
				width: 118px;
				font-family: $rvFontFamily;
				font-weight: 500;
				font-size: 14px;
				line-height: 20px;
				letter-spacing: 0.15px;
				color: $p-color-grey-600;
				background-color: $p-color-grey-100;
			}
			.radio-container input[type="radio"]:checked + label {
				color: $p-color-white;
				background-color: $p-color-blue-300;
				border-radius: 2px;
			}
			.describe-container {
				margin-left: 12px;
				flex-grow: 1;
				.svg-container {
					line-height: 0;
					&.fixed-height {
						height: 136px;
					}
				}
				.features-container {
					@include flex(column, flex-start, flex-start);
					.column-feature {
						@include flex(row);
						margin-bottom: 5px;
						cursor: default;
						.feature-icon {
							margin-right: 7px;
						}
						.feature-label {
							font-family: $rvFontFamily;
							font-weight: 500;
							font-size: 12px;
							line-height: 18px;
							letter-spacing: 0.15px;
							color: $p-color-grey-500;
						}
					}
				}
			}
		}
		.name-container {
			display: flex;
			.name-input {
				font-family: $rvFontFamily;
				font-weight: 500;
				font-size: 14px;
				line-height: 20px;
				letter-spacing: 0.15px;
				color: $p-color-grey-600;
				padding: 10px 9px;
				border: 1px solid $p-color-grey-300;
				outline: none;
				width: 100%;

				&:focus {
					border: 1px solid $p-color-grey-600;
				}
				@include placeholder;
			}
		}
		.submit-button {
			width: 100%;
		}
	}
	.input {
		margin-bottom: 12px;
	}
}
</style>
